import styled from 'styled-components';

export const BottomMenuStyled = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: ${props => props.theme.size.rap};
`;
